import React, { useState, useEffect, useContext, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { TextField, MenuItem, Button, Tabs, Tab } from '@material-ui/core'
import { StyledSection, StyledCard, StyledSlide } from './Hero.style'
import SmoothImage from '../SmoothImage/SmoothImage'
import SellDeviceFormProvider from '../../contexts/SellDeviceFormContext'
import Swiper from 'swiper'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { replaceWhiteSpaceWithHyphen } from 'utils/string_utils'
import { makeHttpRequest } from 'utils/api_utils'
import { useTranslation } from 'react-i18next'
import { getCountryFromUrl } from 'utils/CountryUtils'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    root: {
        '& .swiper-slide img': {},
    },
}))

const Hero = ({ images = [], file_path }) => {
    const classes = useStyles()
    const swiper = useRef(null)
    const { t } = useTranslation()

    useEffect(() => {
        swiper.current = new Swiper('.swiper-container', {
            direction: 'horizontal',
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: {
                delay: 6000,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
            slidesPerColumn: 1,
            loop: false,
            reverseDirection: false,
            stopOnLastSlide: false,
            loopAdditionalSlides: 1000,
            preloadImages: true,
            updateOnImagesReady: true,
            effect: 'fade',
        })

        return function cleanUp() {
            swiper.current = null
        }
    }, [])
    return (
        <StyledSection>
            {/* <StyledMobileSlider className={clsx('swiper-container', classes.root)} style={{overflow:"unset"}}>
                <div className="swiper-wrapper">
                    {images.map(({file_name}, i) => (
                        <div key={i} className="swiper-slide">
                            <SmoothImage src={file_path+file_name} alt={file_name}/>                          
                        </div>
                    ))}
                </div>
                 <div className="swiper-button-next"></div>
                <div className="swiper-button-prev"></div> 
                
                <div className="swiper-pagination"></div>
            </StyledMobileSlider> */}

            <div
                className={clsx('swiper-container', classes.root)}
                style={{ overflow: 'unset' }}
            >
                <div className="swiper-wrapper">
                    {images.map(({ file_name, link = '' }, i) => (
                        <div key={i} className="swiper-slide">
                            <StyledSlide>
                                {link && <a href={link}>Learn more &gt;</a>}
                                <SmoothImage
                                    src={file_path + file_name}
                                    alt={file_name}
                                />
                            </StyledSlide>
                        </div>
                    ))}
                </div>
                {/* <div className="swiper-button-next"></div>
                <div className="swiper-button-prev"></div> */}
                <div className="swiper-pagination"></div>
            </div>
            <HeroForm />
        </StyledSection>
    )
}

export const Hero2 = ({ source = '', images = [], file_path }) => {
    const classes = useStyles()
    const swiper = useRef(null)

    useEffect(() => {
        swiper.current = new Swiper('.swiper-container', {
            direction: 'horizontal',
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: {
                delay: 6000,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
            slidesPerColumn: 1,
            loop: false,
            reverseDirection: false,
            stopOnLastSlide: false,
            loopAdditionalSlides: 1000,
            preloadImages: true,
            updateOnImagesReady: true,
            effect: 'fade',
        })

        return function cleanUp() {
            swiper.current = null
        }
    }, [])
    return (
        <StyledSection>
            <div
                className={clsx('swiper-container', classes.root)}
                style={{ overflow: 'unset' }}
            >
                <div className="swiper-wrapper">
                    {images.map(({ file_name }, i) => (
                        <div key={i} className="swiper-slide">
                            <SmoothImage
                                src={file_path + file_name}
                                alt={file_name}
                            />
                        </div>
                    ))}
                </div>
                {/* <div className="swiper-button-next"></div>
                <div className="swiper-button-prev"></div> */}
                <div className="swiper-pagination"></div>
            </div>
            {/* <HeroForm2 source={source}/> */}
        </StyledSection>
    )
}

const HeroForm = ({ source = '' }) => {
    const history = useHistory()
    const { t } = useTranslation()
    const { pathname } = useLocation()
    // let country = getCountryFromUrl(pathname)||"ke"
    let country = localStorage.getItem('country')

    const SellDeviceFormContext = useContext(SellDeviceFormProvider)
    const {
        setModels,
        models,
        colors,
        setBuyModels,
        buyModels,
        setSelectedModel,
        setSelectedBuyModel,
        requestBody,
        fetchVariants,
        setRequestBody,
        setRequestBuyBody,
        selectedModel,
        selectedBuyModel,
    } = SellDeviceFormContext
    const [error, setError] = useState({})
    const [brands, setBrands] = useState([])
    const [activeColor, setActiveColor] = useState('#58cab9')
    const [selectedRepair, setSelectedRepair] = useState({
        modelId: '',
        colorId: '',
    })
    const [selectedTab, setSelectedTab] = useState(0)
    const useStyles = makeStyles((theme) => ({
        root: {
            flexGrow: 1,
        },
        buyInput: {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(0, 0, 0, 0.23)',
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                {
                    borderColor: '#F68937 !important',
                    color: 'blue',
                },
            '& .MuiFormLabel-root.Mui-focused ': {
                color: '#F68937 !important',
            },
        },
        repairInput: {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(0, 0, 0, 0.23)',
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                {
                    borderColor: 'rgb(111, 101, 173) !important',
                    color: 'blue',
                },
            '& .MuiFormLabel-root.Mui-focused ': {
                color: 'rgb(111, 101, 173) !important',
            },
        },
    }))

    const classes = useStyles()

    const StyledTabs = withStyles({
        indicator: {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'transparent',
            '& > span': {
                maxWidth: 60,
                width: '100%',
                backgroundColor: `${activeColor}`,
            },
        },
    })((props) => (
        <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />
    ))

    const StyledTab = withStyles((theme) => ({
        root: {
            textTransform: 'none',
            width: '50%',
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(15),
            marginRight: theme.spacing(1),
            '&:focus': {
                opacity: 1,
            },
            '&.Mui-selected': {
                color: `${activeColor}`,
            },
        },
    }))((props) => <Tab disableRipple {...props} />)

    // const fetchBrands = async (_id) => {
    //     const { success, brands } = await makeHttpRequest(
    //         `get_device/${_id}`,
    //         'GET'
    //     )
    //     if (success) {
    //         setBrands(brands)
    //     } else {
    //         setError({
    //             status: true,
    //             msg: 'an error occurred that prevented the brands from loading...',
    //         })
    //         return
    //     }
    // }

    const fetchModels = async (brandId) => {
        const { success, deviceModels } = await makeHttpRequest(
            `get_device_model/${brandId}`,
            'GET'
        )

        if (success) {
            setModels(deviceModels)
        }
    }
    const fetchBuyModels = async (brandId) => {
        let { success, deviceModels } = await makeHttpRequest(
            `get_available_by_brands/${brandId}`,
            'GET'
        )
        if (success) setBuyModels(deviceModels)
    }

    const handleSelectModel = (model) => {
        setSelectedModel({ ...model.details, image: model.image })
        setRequestBody({
            ...requestBody,
            modelID: model.details._id,
        })
        fetchVariants(model.details._id)
    }
    const handleSelectBuyModel = async (model) => {
        setSelectedBuyModel({ ...model })
        setRequestBuyBody({
            ...requestBody,
            modelID: model._id,
        })
        fetchVariants(model._id)
    }
    const handleRepair = (e) => {
        const { value, name } = e.target

        setSelectedRepair({ ...selectedRepair, [name]: value })
    }

    const handleTabChange = (event, newValue) => {
        if (newValue === 0) {
            setActiveColor('#58cab9')
        } else if (newValue === 1) {
            setActiveColor('rgb(111, 101, 173)')
        } else if (newValue === 2) {
            setActiveColor('#F68937')
        }
        setSelectedTab(newValue)
    }
    // const handleTabChange = (event, newValue) => {
    //     if (newValue === 0) {
    //         setActiveColor('#58cab9')
    //     } else if (newValue === 1) {
    //         setActiveColor('#F68937')
    //     }
    //     setSelectedTab(newValue)
    // }
    useEffect(() => {
        let isMounted = true // Flag to track if the component is mounted

        const fetchBrands = async (_id) => {
            const { success, brands } = await makeHttpRequest(
                `get_device/${_id}`,
                'GET'
            )
            if (isMounted) {
                // Check if the component is still mounted before updating state
                if (success) {
                    setBrands(brands)
                } else {
                    setError({
                        status: true,
                        msg: 'an error occurred that prevented the brands from loading...',
                    })
                }
            }
        }

        fetchBrands('6165c8453c6ca93814dc21aa')
        setSelectedModel({})
        setSelectedBuyModel({})
        // Cleanup function to cancel any ongoing tasks
        return () => {
            isMounted = false // Set the flag to false when unmounting
        }
    }, [])
    // useEffect(() => {
    //     fetchBrands('6165c8453c6ca93814dc21aa')
    //     setSelectedModel({})
    //     setSelectedBuyModel({})
    //     return function cleanUp() {}
    // }, [])

    // const items = ['Sell', 'Buy']
    // const items = [`${t('sell')}`, `${t('repair')}`, `${t('buy')}`]
    const items = [`${t('description.sell_title')}`]

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }

    return (
        <StyledCard>
            <StyledTabs
                variant="fullWidth"
                value={selectedTab}
                onChange={handleTabChange}
                aria-label="simple tabs example"
                className={`${classes.root} mb-8`}
            >
                {items?.map((item, i) => (
                    <StyledTab
                        label={item}
                        key={i}
                        style={{
                            minWidth: `${item.length}` + `em`,
                            paddingInline: '2em',
                        }}
                        {...a11yProps(i)}
                    />
                ))}
            </StyledTabs>

            <div
                role="tabpanel"
                hidden={selectedTab !== 0}
                id={`full-width-tabpanel-${0}`}
                aria-labelledby={`full-width-tab-${0}`}
            >
                {brands && brands.length > 0 ? (
                    <TextField
                        className="input-select mb-4"
                        label={t('description.select_brand')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue={''}
                        select
                    >
                        {brands?.map((brand) => (
                            <MenuItem
                                key={brand._id}
                                value={brand.brand}
                                onClick={() => fetchModels(brand._id)}
                            >
                                {brand.brand}
                            </MenuItem>
                        ))}
                    </TextField>
                ) : (
                    <TextField
                        className="input-select mb-4"
                        label={t('description.select_brand')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue=""
                        select
                        disabled
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                    </TextField>
                )}
                {brands && brands.length > 0 && models && models.length > 0 ? (
                    <TextField
                        className="input-select mb-4"
                        label={t('description.select_model')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue=""
                        select
                    >
                        {models?.map((model) => (
                            <MenuItem
                                key={model.details.modelName}
                                value={model.details.modelName}
                                onClick={() =>
                                    handleSelectModel({
                                        ...model,
                                        ...model.image,
                                    })
                                }
                            >
                                {model.details.modelName}
                            </MenuItem>
                        ))}
                    </TextField>
                ) : (
                    <TextField
                        className="input-select mb-4"
                        label={t('description.select_model')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue=""
                        select
                        disabled
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                    </TextField>
                )}
                <Button
                    className="px-7 text-white"
                    variant="contained"
                    disabled={!selectedModel || !selectedModel._id}
                    color="primary"
                    onClick={() =>
                        history.push(
                            `/${country}/sell-old-mobile-phone/select-variant/${selectedModel._id}`,
                            { from: source ? '/partners' : '/home' }
                        )
                    }
                >
                    {t('description.sell')}
                </Button>
            </div>
            <div
                role="tabpanel"
                hidden={selectedTab !== 1}
                id={`full-width-tabpanel-${1}`}
                aria-labelledby={`full-width-tab-${1}`}
            >
                {brands && brands.length > 0 ? (
                    <TextField
                        className={`${classes.repairInput} input-select mb-4`}
                        label={t('description.select_brand')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue={''}
                        select
                        onChange={handleRepair}
                        name="brandId"
                    >
                        {brands.map((brand) => (
                            <MenuItem
                                key={brand._id}
                                value={brand.brand}
                                onClick={() => fetchBuyModels(brand._id)}
                            >
                                {brand.brand}
                            </MenuItem>
                        ))}
                    </TextField>
                ) : (
                    <TextField
                        className={`${classes.repairInput} input-select mb-4`}
                        label={t('description.select_brand')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue=""
                        select
                        disabled
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                    </TextField>
                )}
                {brands &&
                brands.length > 0 &&
                buyModels &&
                buyModels.length > 0 ? (
                    <TextField
                        className={`${classes.repairInput} input-select mb-4`}
                        label={t('description.select_model')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue=""
                        select
                        onChange={handleRepair}
                        name="modelId"
                    >
                        {buyModels?.map(({ _id, modelName }) => (
                            <MenuItem
                                key={_id}
                                value={_id}
                                onClick={() => fetchVariants(_id)}
                            >
                                {modelName}
                            </MenuItem>
                        ))}
                    </TextField>
                ) : (
                    <TextField
                        className={`${classes.repairInput} input-select mb-4`}
                        label={t('description.select_model')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue=""
                        select
                    >
                        <MenuItem value="">
                            <em>No available models</em>
                        </MenuItem>
                    </TextField>
                )}
                <TextField
                    className={`${classes.repairInput} input-select mb-4`}
                    label={t('description.color')}
                    variant="outlined"
                    size="small"
                    fullWidth
                    defaultValue={''}
                    select
                    onChange={handleRepair}
                    name="colorId"
                    disabled={!colors.length > 0}
                >
                    {colors?.map(({ value, label }) => (
                        <MenuItem key={value} value={value}>
                            {label}
                        </MenuItem>
                    ))}
                </TextField>
                <Button
                    className="px-7 text-white"
                    style={{
                        background:
                            !selectedRepair.modelId || !selectedRepair.colorId
                                ? '#ccc'
                                : 'rgb(111, 101, 173)',
                    }}
                    color="primary"
                    disabled={
                        !selectedRepair.modelId || !selectedRepair.colorId
                    }
                    onClick={() => {
                        history.push({
                            pathname: `/${country}/repair/${replaceWhiteSpaceWithHyphen(
                                selectedRepair.modelId
                            )}`,

                            state: {
                                _id: selectedRepair.modelId,
                                modelId: selectedRepair.modelId,
                                colorId: selectedRepair.colorId,
                            },
                        })
                    }}
                >
                    {t('description.repair')}
                </Button>
            </div>

            <div
                role="tabpanel"
                hidden={selectedTab !== 2}
                id={`full-width-tabpanel-${2}`}
                aria-labelledby={`full-width-tab-${2}`}
            >
                {brands && brands.length > 0 ? (
                    <TextField
                        className={`${classes.buyInput} input-select mb-4`}
                        label={t('description.select_brand')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue={''}
                        select
                    >
                        {brands?.map((brand) => (
                            <MenuItem
                                key={brand._id}
                                value={brand.brand}
                                onClick={() => fetchBuyModels(brand._id)}
                            >
                                {brand.brand}
                            </MenuItem>
                        ))}
                    </TextField>
                ) : (
                    <TextField
                        className={`${classes.buyInput} input-select mb-4`}
                        label={t('description.select_brand')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue=""
                        select
                        disabled
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                    </TextField>
                )}
                {brands &&
                brands.length > 0 &&
                buyModels &&
                buyModels.length > 0 ? (
                    <TextField
                        className={`${classes.buyInput} input-select mb-4`}
                        label={t('description.select_model')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue=""
                        select
                    >
                        {buyModels?.map((model) => (
                            <MenuItem
                                key={model.modelName}
                                value={model.modelName}
                                onClick={() =>
                                    handleSelectBuyModel({
                                        ...model,
                                    })
                                }
                            >
                                {model.modelName}
                            </MenuItem>
                        ))}
                    </TextField>
                ) : (
                    <TextField
                        className={`${classes.buyInput} input-select mb-4`}
                        label={t('description.select_model')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        defaultValue=""
                        select
                    >
                        <MenuItem value="">
                            <em>No available models</em>
                        </MenuItem>
                    </TextField>
                )}
                <Button
                    className="px-7 text-white"
                    style={{ background: '#F68937' }}
                    disabled={!selectedBuyModel || !selectedBuyModel._id}
                    color="primary"
                    onClick={() =>
                        //old link
                        // history.push({
                        //     pathname: `/${country}/ecommerce/details/${replaceWhiteSpaceWithHyphen(
                        //         selectedBuyModel.modelName
                        //     )}`,

                        //     state: { _id: selectedBuyModel._id },
                        // })
                        // redirect to shopify store
                        (window.location = 'https://shop.badili.ke/')
                    }
                >
                    {t('description.buy')}
                </Button>
            </div>
        </StyledCard>
    )
}

export default Hero
